import {Injectable} from '@angular/core';
import {DcpPriceDisplayData, DcpPriceSubscriptionLabels} from '@dcp/configurator';
import {ProductPageDecoratorService} from '../../product/services/product-page-decorator.service';

@Injectable({
  providedIn: 'root',
})
export class PriceDisplayService {
  constructor(private productPageDecoratorService: ProductPageDecoratorService) {}

  public selectSubscriptionLabelByCurrency(
    priceDisplay: DcpPriceDisplayData,
    currency: string
  ): DcpPriceSubscriptionLabels {
    const globalPriceDisplay = priceDisplay?.[this.productPageDecoratorService.getGlobalCurrencyKey(currency)];
    const countryPriceDisplay = priceDisplay?.[this.productPageDecoratorService.getCountryCurrencyKey(currency)];

    return countryPriceDisplay || globalPriceDisplay;
  }
}
